import { Alert, AlertIcon, Box, CloseButton } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { Reclassification } from "./useReclassification";

export const ReclassificationNotice = ({
  reclassification,
  onDismiss,
  mt = "3",
  mb,
}: {
  reclassification: Reclassification;
  onDismiss: () => void;
  mt?: string;
  mb?: string;
}) => {
  const { t } = useTranslation();
  const parts = { from: t(reclassification.from), to: t(reclassification.to) };
  return (
    <Alert
      status="info"
      role="status"
      mt={mt}
      mb={mb}
      borderRadius="md"
      fontSize="sm"
      alignItems="flex-start"
    >
      <AlertIcon />
      <Box flex="1">
        {reclassification.cause === "regulation"
          ? t(
              "The change of regulation moved this procurement from {{from}} to {{to}}",
              parts,
            )
          : reclassification.cause === "serviceCategory"
            ? t(
                "The answer about the kind of service moved this procurement from {{from}} to {{to}}",
                parts,
              )
            : reclassification.cause === "contractNature"
              ? t(
                  "The change of contract type moved this procurement from {{from}} to {{to}}",
                  parts,
                )
              : t(
                "The change in estimated value moved this procurement from {{from}} to {{to}}",
                parts,
              )}
      </Box>
      <CloseButton
        size="md"
        aria-label={t("Close") ?? undefined}
        onClick={onDismiss}
      />
    </Alert>
  );
};
